// product.js: PDP do tema Clube Rock 2026 (módulo; orçamento ≤ 6 KB minificado, decisão do JARVIS de 2026-10-15).
// Melhora progressiva: sem este arquivo a PDP funciona (cor = links, tamanho = rádios name="id", form POST /cart/add).
// Seleção (L3-1/L3-2): um estado só, a variante CONFIRMADA. Cada troca (cor ou tamanho) resolve a combinação no cliente
//   pelo JSON das variantes, pede as regiões [data-cr-sra] (preço, trio, cores, tamanhos, botão, id) pela Section
//   Rendering API e só aplica a resposta do pedido MAIS RECENTE; respostas antigas são descartadas. URL e rádio mudam
//   depois da resposta. Em erro ou demora (8 s), navega para a variante pedida (a página recarrega certa).
//   Cor nova sem o tamanho escolhido (inexistente ou esgotado): a grade vem sem marcação e pede o tamanho de novo.
// Adição (L3-3, L3-v2-1/2): uma trava para todas as portas (botão, barra fixa, Enter); não envia com seleção pendente.
//   O resultado do POST /cart/add.js decide sucesso ou erro e libera a PDP na hora. Sucesso → 1 confirmação + 1
//   CR.analytics.addToCart com a quantidade PEDIDA (o add.js devolve a acumulada da linha). Depois, leitura auxiliar do
//   /cart.js com prazo de 5 s e sequência própria; em falha soma ao contador os incrementos sem leitura. cr:cart:updated
//   abre o drawer (assets/cart.js).
// Barra fixa (celular): só quando o botão principal sai da tela. Galeria: pontos, zoom em <dialog>, rola até a foto.
const raiz = document.querySelector('[data-cr-pdp]');
if (raiz) iniciar(raiz);

function iniciar(raiz) {
  const secao = raiz.dataset.secao;
  const form = document.getElementById('cr-pdp-form');
  const variantes = JSON.parse(document.querySelector('[data-cr-variantes]')?.textContent || '[]');
  const status = raiz.querySelector('[data-cr-status]');
  const moeda = (c) => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const porId = (id) => variantes.find((x) => String(x.id) === String(id));
  const radios = () => form?.querySelectorAll('input[type="radio"][name="id"]') || [];
  const temTamanhos = () => radios().length > 0;
  // índices das opções (mesma regra do Liquid: nome com "tamanho"; "cor"/"cores"/"color")
  const nomes = JSON.parse(raiz.dataset.opcoes || '[]').map((n) => String(n).toLowerCase());
  const iTam = nomes.findIndex((n) => n.includes('tamanho'));
  const iCor = nomes.findIndex((n) => n === 'cor' || n === 'cores' || n === 'color');

  // Estado: variante confirmada (com tamanho escolhido) ou null; variante exibida (cor atual, para a grade)
  const marcado = form?.querySelector('input[name="id"]:checked');
  let confirmada = marcado ? porId(marcado.value) : (temTamanhos() ? null : porId(form?.querySelector('input[name="id"]')?.value));
  let seq = 0;
  let pendente = false;
  let ocupado = false;
  let enviar = false; // AUD-T: envio pedido durante a troca de variante
  const cache = new Map(); // url → texto (só respostas boas; falha não fica guardada)

  async function buscar(url) {
    if (cache.has(url)) return cache.get(url);
    const ctl = new AbortController();
    const t = setTimeout(() => ctl.abort(), 8000);
    try {
      const r = await fetch(url, { signal: ctl.signal });
      if (!r.ok) throw new Error(String(r.status));
      const txt = await r.text();
      cache.set(url, txt);
      return txt;
    } finally { clearTimeout(t); }
  }

  function travarBotoes(sim) {
    for (const b of [raiz.querySelector('[data-cr-botao]'), fixa?.querySelector('[data-cr-fixa-botao]')]) {
      if (!b) continue;
      if (sim) { b.setAttribute('aria-busy', 'true'); b.dataset.travado = '1'; } else { b.removeAttribute('aria-busy'); delete b.dataset.travado; }
    }
  }

  // Aplica a seleção pedida: alvo = variante a renderizar; escolhida = variante com tamanho (ou null = sem tamanho);
  // rolar = levar a galeria à foto da variante: só na troca de cor (S19: escolher o tamanho não tira a foto do card)
  async function aplicar(alvo, escolhida, rolar = true) {
    const meu = ++seq;
    pendente = true;
    travarBotoes(true);
    try {
      const html = await buscar(`${raiz.dataset.url}?variant=${alvo.id}&section_id=${secao}`);
      if (meu !== seq) return false; // chegou depois de um pedido mais novo: descarta
      const doc = new DOMParser().parseFromString(html, 'text/html');
      // AUD-T (L10r): o foco num controle das regiões trocadas (botão Adicionar ou rádio de tamanho) volta para o mesmo
      // controle na região nova; antes caía no <body> (Tab recomeçava do topo e o Enter seguinte não fazia nada)
      const ativo = document.activeElement;
      const foco = ativo?.closest?.('[data-cr-sra]') && (ativo.matches('[data-cr-botao]') ? '[data-cr-botao]' : ativo.name === 'id' ? `input[name="id"][value="${ativo.value}"]` : '');
      for (const atual of raiz.querySelectorAll('[data-cr-sra]')) {
        const novo = doc.querySelector(`[data-cr-sra="${atual.dataset.crSra}"]`);
        if (novo) atual.replaceWith(novo);
      }
      if (foco && !raiz.contains(document.activeElement)) raiz.querySelector(foco)?.focus({ preventScroll: true });
      for (const r of radios()) { const sim = !!escolhida && r.value === String(escolhida.id); r.checked = sim; r.toggleAttribute('checked', sim); }
      confirmada = escolhida;
      // URL: com tamanho, ?variant= da escolhida; sem tamanho (cor nova sem a combinação), tira o variant para que
      // recarregar/compartilhar não marque um tamanho por acidente (a cor volta à padrão do produto: limite aceito)
      const u = new URL(location.href);
      if (escolhida) u.searchParams.set('variant', escolhida.id); else u.searchParams.delete('variant');
      history.replaceState({}, '', u);
      if (rolar && alvo.media) rolarAteMidia(alvo.media);
      atualizarFixa();
      document.dispatchEvent(new Event('cr:variante')); // L9n: seleção aplicada (tamanho ou cor); o kit.js relê a vaga provisória
      return true;
    } catch {
      if (meu === seq) { enviar = false; location.href = `${raiz.dataset.url}?variant=${(escolhida || alvo).id}`; }
      return false;
    } finally {
      if (meu === seq) {
        pendente = false; if (!ocupado) travarBotoes(false);
        // AUD-T (L10r): o envio pedido durante a troca sai agora, com a variante já aplicada (antes era descartado em silêncio)
        if (enviar) { enviar = false; form?.requestSubmit(); }
      }
    }
  }

  // Cor: mantém o tamanho escolhido se existir e estiver disponível na cor nova; senão pede o tamanho de novo
  raiz.addEventListener('click', (e) => {
    const cor = e.target.closest('[data-cr-cor]');
    if (!cor) return;
    e.preventDefault();
    const valorCor = cor.dataset.crCor;
    const tam = confirmada && iTam >= 0 ? confirmada.options[iTam] : null;
    const mesma = tam && variantes.find((v) => v.options[iCor] === valorCor && v.options[iTam] === tam && v.available);
    const daCor = porId(cor.dataset.crVariante) || variantes.find((v) => v.options[iCor] === valorCor);
    if (!daCor) { location.href = cor.href; return; }
    if (mesma) { aplicar(mesma, mesma); return; }
    aplicar(daCor, temTamanhos() ? null : daCor).then((ok) => { if (ok && tam) pedirTamanho(false); });
  });

  // Tamanho
  form?.addEventListener('change', (e) => {
    if (e.target.name !== 'id') return;
    raiz.querySelector('[data-cr-erro-tamanho]')?.setAttribute('hidden', '');
    const v = porId(e.target.value);
    if (v) aplicar(v, v, false);
  });

  function pedirTamanho(rolar = true) {
    raiz.querySelector('[data-cr-erro-tamanho]')?.removeAttribute('hidden');
    if (!rolar) return;
    form.querySelector('.cr-pdp__tamanhos')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    form.querySelector('input[name="id"]:not([disabled])')?.focus({ preventScroll: true });
  }
  form?.addEventListener('invalid', (e) => { if (e.target.name === 'id') { e.preventDefault(); pedirTamanho(); } }, true);

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (ocupado) return; // uma adição por vez
    // AUD-T (L10r): com a seleção ainda trocando (SRA em curso), o envio espera e sai quando a troca termina (finally de
    // aplicar); nada sai com a seleção antiga
    if (pendente) { enviar = true; return; }
    if (temTamanhos() && !confirmada) { pedirTamanho(); return; }
    const marcadoAgora = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    if (!confirmada || !marcadoAgora || marcadoAgora.value !== String(confirmada.id)) return; // tela e estado divergem
    ocupado = true;
    travarBotoes(true);
    const botao = raiz.querySelector('[data-cr-botao]');
    const texto = botao?.textContent;
    // textos dos data-* do main-product.liquid, sempre renderizados (L10r: sem cópia em JS, pelo orçamento de 6 KB)
    if (botao) { botao.disabled = true; botao.textContent = botao.dataset.adicionando; }
    const corpo = new FormData(form);
    // quantidade PEDIDA nesta ação (L3-v2-1): o /cart/add.js devolve a quantidade acumulada da linha
    const pedida = Math.max(1, parseInt(corpo.get('quantity'), 10) || 1);
    let dados = null;
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: corpo });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || 'erro');
      dados = j;
    } catch {
      status.textContent = status.dataset.erro;
    }
    // a PDP volta a ficar livre assim que o POST decide (L3-v2-2); a leitura do carrinho não segura a compra
    const b = raiz.querySelector('[data-cr-botao]'); // pode ter sido trocado pela SRA durante a adição
    if (b) { b.disabled = false; if (b === botao && texto) b.textContent = texto; }
    ocupado = false;
    if (!pendente) travarBotoes(false);
    if (dados) {
      // mutação confirmada: uma confirmação e um ATC, com o incremento desta ação
      const item = { ...dados, quantity: pedida };
      status.innerHTML = `${status.dataset.ok} <a href="/cart" data-abre-carrinho>${status.dataset.verCarrinho}</a>`;
      try { window.CR?.analytics?.addToCart?.([item], { origem: 'pdp' }); } catch { /* analytics nunca bloqueia a compra */ }
      lerCarrinho(item);
    }
  });

  // Leitura auxiliar do carrinho depois de uma adição: prazo de 5 s (cabeçalho e corpo); só a leitura mais recente
  // vale. Incrementos de adições ainda sem leitura se somam: em falha/demora, o contador recebe essa soma (nunca a
  // quantidade acumulada da linha) e o evento sai com cart: null.
  let seqCarrinho = 0;
  let semLeitura = 0;
  async function lerCarrinho(item) {
    const meu = ++seqCarrinho;
    semLeitura += item.quantity;
    let carrinho = null;
    const ctl = new AbortController();
    const t = setTimeout(() => ctl.abort(), 5000);
    try {
      const r = await fetch('/cart.js', { signal: ctl.signal });
      if (r.ok) carrinho = await Promise.race([r.json(), new Promise((_, rej) => ctl.signal.addEventListener('abort', () => rej(new Error('prazo'))))]);
    } catch { carrinho = null; } finally { clearTimeout(t); }
    if (meu !== seqCarrinho) return; // uma adição mais nova vai decidir o contador
    const ok = carrinho && typeof carrinho.item_count === 'number';
    for (const el of document.querySelectorAll('[data-cart-count]')) { const n = ok ? carrinho.item_count : (parseInt(el.textContent, 10) || 0) + semLeitura; el.textContent = n; el.hidden = n === 0; }
    semLeitura = 0;
    document.dispatchEvent(new CustomEvent('cr:cart:updated', { detail: { cart: ok ? carrinho : null, item } }));
  }

  // Barra fixa do celular
  const fixa = document.querySelector('[data-cr-fixa]');
  const fixaTexto = fixa?.querySelector('[data-cr-fixa-texto]');
  function atualizarFixa() {
    if (!fixaTexto) return;
    fixaTexto.textContent = confirmada ? `${fixa.dataset.adicionar} · ${moeda(confirmada.price)}` : fixa.dataset.escolha;
  }
  if (fixa && 'IntersectionObserver' in window) {
    // D-2: margem inferior enorme = "abaixo da dobra" conta como visível; sair por cima sempre dispara, mesmo num salto
    // de rolagem que nunca deixa o botão na tela (antes, de fora-embaixo para fora-em-cima não havia callback)
    const io = new IntersectionObserver(([entrada]) => { fixa.hidden = entrada.isIntersecting; }, { rootMargin: '0px 0px 99999px 0px' });
    const alvo = () => raiz.querySelector('[data-cr-botao]');
    if (alvo()) io.observe(alvo());
    new MutationObserver(() => { io.disconnect(); if (alvo()) io.observe(alvo()); }).observe(raiz, { childList: true, subtree: true });
    fixa.querySelector('[data-cr-fixa-botao]')?.addEventListener('click', () => {
      if (temTamanhos() && !confirmada) pedirTamanho();
      else form.requestSubmit(); // a trava do submit vale para esta porta também
    });
    atualizarFixa();
  }

  // Galeria: pontos e zoom
  const faixa = raiz.querySelector('[data-galeria-faixa]');
  const pontos = raiz.querySelectorAll('.cr-galeria__ponto');
  if (faixa && pontos.length && 'IntersectionObserver' in window) {
    const itens = [...faixa.children];
    const io = new IntersectionObserver((es) => {
      for (const en of es) if (en.isIntersecting) { const i = itens.indexOf(en.target); pontos.forEach((p, k) => p.classList.toggle('is-ativo', k === i)); }
    }, { root: faixa, threshold: 0.6 });
    itens.forEach((it) => io.observe(it));
  }
  function rolarAteMidia(id) {
    const el = document.getElementById(`Midia-${secao}-${id}`);
    if (el && faixa) faixa.scrollTo({ left: el.offsetLeft - faixa.offsetLeft, behavior: 'auto' });
  }
  const zoom = document.querySelector('[data-zoom-dialog]');
  raiz.addEventListener('click', (e) => {
    const link = e.target.closest('[data-zoom]');
    if (!link || !zoom || typeof zoom.showModal !== 'function') return;
    e.preventDefault();
    zoom.querySelector('[data-zoom-img]').src = link.href;
    zoom.querySelector('[data-zoom-img]').alt = link.querySelector('img')?.alt || '';
    zoom.showModal();
  });
}
